import { EChartsCoreOption } from 'echarts';
import { useMemo } from 'react';
import ChartComponent from 'src/helpers/Echarts/ChartComponent';
import { generateToDChartOptions, zoneColors } from './modules';

type Props = {
    data: any,
}

const BillComparison = ({ data }: Props) => {

    const { beforeMYTData, afterMYTData, xLabels, change } = useMemo(() => {

        let beforeMYTData: any[] = [];
        let afterMYTData: any[] = [];
        let change: any[] = [];

        let _data = data && Object.values(data)


        let xLabels = _data?.map((d: any) => d?.parameter)

        beforeMYTData = _data?.map((d: any) => {
            return {
                value: Number(d?.oldTariff).toFixed(2),
                itemStyle: {
                    color: d?.oldTariff && Number(d?.oldTariff) < 0 ? '#FF0000' : zoneColors[`Zone B`],
                }
            }
        })


        afterMYTData = _data?.map((d: any) => {
            return {
                value: Number(d?.newTariff).toFixed(2),
                itemStyle: {
                    color: d?.newTariff && Number(d?.newTariff) < 0 ? '#FF0000' : zoneColors[`Zone D`],
                }
            }
        })

        change = _data?.map((d: any) => {
            return {
                value: Number(d?.change).toFixed(2),
                itemStyle: {
                    color: d?.change && Number(d?.change) < 0 ? '#FF0000' : zoneColors[`Zone D`],
                }
            }
        })


        return { beforeMYTData, afterMYTData, xLabels, change };
    }, [data])



    // console.log({ data, beforeMYTData, afterMYTData, zoneColors, change });


    const options: EChartsCoreOption = useMemo(
        () => (
            {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                legend: {
                    data: ['beforeMYT', 'afterMYT'],
                    show: false
                },
                grid: {
                    left: '10%',
                    right: '30%', // Increased right margin to make space for the table
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'value',
                    name: 'Value',
                    show: false
                },
                yAxis: {
                    type: 'category',
                    name: 'Category',
                    axisTick: {
                        show: false
                    },
                    data: [
                        'Tax On Sale @ 0.1904/unit',
                        'Electricity Duty @ 7.5%',
                        'FAC @ 0.65/unit',
                        'Zone Rebates',
                        'Wheeling Charges',
                        'Energy Charges',
                        'Demand Charges'
                    ]
                },
                series: [
                    {
                        name: 'before MYT',
                        type: 'bar',
                        // stack: 'Total',
                        label: {
                            show: false,
                            position: 'inside'
                        },
                        emphasis: {
                            focus: 'series'
                        },
                        data: beforeMYTData
                    },
                    // {
                    //     name: 'after MYT',
                    //     type: 'bar',
                    //     // stack: 'Total',
                    //     label: {
                    //         show: false,
                    //         position: 'inside'
                    //     },
                    //     emphasis: {
                    //         focus: 'series'
                    //     },

                    //     data: afterMYTData
                    // }
                ],
            }
        ),
        [beforeMYTData, afterMYTData, xLabels]
    );

    return (

        <div className=' relative bg-slate-200'>
            <ChartComponent options={options} style={{ height: "350px" }} />
        </div>

    );
}

export default BillComparison